export const QUEST_REWARDS_CHANGED = "varnax:quest-rewards-changed";
export interface QuestRewardProgress { id: string; progress: number; target: number; claimed?: boolean; rewardGold?: number; rewardDiamonds?: number }

export function countClaimableQuestRewards(items: readonly QuestRewardProgress[]): number {
  const ready = new Set<string>();
  for (const item of items) {
    if (item && typeof item.id === "string" && item.id && item.claimed !== true
      && Number.isFinite(item.target) && item.target > 0 && Number.isFinite(item.progress) && item.progress >= item.target
      && ((Number.isFinite(item.rewardGold) && item.rewardGold! > 0) || (Number.isFinite(item.rewardDiamonds) && item.rewardDiamonds! > 0))) ready.add(item.id);
  }
  return ready.size;
}

export function notifyQuestRewardsChanged(profileId: string): void {
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent(QUEST_REWARDS_CHANGED, { detail: { profileId } }));
}

/** Newer claims, identity changes and unmounts invalidate older responses. */
export class QuestRewardRequestGate {
  private revision = 0;
  invalidate(): void { this.revision++; }
  async refresh(load: () => Promise<{ items: QuestRewardProgress[] }>, commit: (count: number) => void): Promise<void> {
    const revision = ++this.revision;
    try {
      const result = await load();
      if (revision === this.revision) commit(Array.isArray(result.items) ? countClaimableQuestRewards(result.items) : 0);
    } catch { /* A transient network error must not invent or re-enable rewards. */ }
  }
}
